function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
!function (t, s) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = s() : "function" == typeof define && define.amd ? define(s) : t.dayjs_plugin_duration = s();
}(this, function () {
  "use strict";

  var t,
    s,
    n = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,
    i = {
      years: 31536e6,
      months: 2592e6,
      days: 864e5,
      hours: 36e5,
      minutes: 6e4,
      seconds: 1e3,
      milliseconds: 1,
      weeks: 6048e5
    },
    e = function e(t) {
      return t instanceof u;
    },
    r = function r(t, s, n) {
      return new u(t, n, s.$l);
    },
    o = function o(t) {
      return s.p(t) + "s";
    },
    u = function () {
      function s(t, s, e) {
        var u = this;
        if (this.$d = {}, this.$l = e, s) return r(t * i[o(s)], this);
        if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
        if ("object" == _typeof(t)) return Object.keys(t).forEach(function (s) {
          u.$d[o(s)] = t[s];
        }), this.calMilliseconds(), this;
        if ("string" == typeof t) {
          var h = t.match(n);
          if (h) return this.$d.years = h[2], this.$d.months = h[3], this.$d.weeks = h[4], this.$d.days = h[5], this.$d.hours = h[6], this.$d.minutes = h[7], this.$d.seconds = h[8], this.calMilliseconds(), this;
        }
        return this;
      }
      var u = s.prototype;
      return u.calMilliseconds = function () {
        var t = this;
        this.$ms = Object.keys(this.$d).reduce(function (s, n) {
          return s + (t.$d[n] || 0) * i[n];
        }, 0);
      }, u.parseFromMilliseconds = function () {
        var t = this.$ms;
        this.$d.years = Math.floor(t / 31536e6), t %= 31536e6, this.$d.months = Math.floor(t / 2592e6), t %= 2592e6, this.$d.days = Math.floor(t / 864e5), t %= 864e5, this.$d.hours = Math.floor(t / 36e5), t %= 36e5, this.$d.minutes = Math.floor(t / 6e4), t %= 6e4, this.$d.seconds = Math.floor(t / 1e3), t %= 1e3, this.$d.milliseconds = t;
      }, u.toISOString = function () {
        var t = this.$d.years ? this.$d.years + "Y" : "",
          s = this.$d.months ? this.$d.months + "M" : "",
          n = +this.$d.days || 0;
        this.$d.weeks && (n += 7 * this.$d.weeks);
        var i = n ? n + "D" : "",
          e = this.$d.hours ? this.$d.hours + "H" : "",
          r = this.$d.minutes ? this.$d.minutes + "M" : "",
          o = this.$d.seconds || 0;
        this.$d.milliseconds && (o += this.$d.milliseconds / 1e3);
        var u = o ? o + "S" : "",
          h = "P" + t + s + i + (e || r || u ? "T" : "") + e + r + u;
        return "P" === h ? "P0D" : h;
      }, u.toJSON = function () {
        return this.toISOString();
      }, u.as = function (t) {
        return this.$ms / i[o(t)];
      }, u.get = function (t) {
        var s = this.$ms,
          n = o(t);
        return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? Math.floor(s / i[n]) : this.$d[n], s;
      }, u.add = function (t, s, n) {
        var u;
        return u = s ? t * i[o(s)] : e(t) ? t.$ms : r(t, this).$ms, r(this.$ms + u * (n ? -1 : 1), this);
      }, u.subtract = function (t, s) {
        return this.add(t, s, !0);
      }, u.locale = function (t) {
        var s = this.clone();
        return s.$l = t, s;
      }, u.clone = function () {
        return r(this.$ms, this);
      }, u.humanize = function (s) {
        return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
      }, u.milliseconds = function () {
        return this.get("milliseconds");
      }, u.asMilliseconds = function () {
        return this.as("milliseconds");
      }, u.seconds = function () {
        return this.get("seconds");
      }, u.asSeconds = function () {
        return this.as("seconds");
      }, u.minutes = function () {
        return this.get("minutes");
      }, u.asMinutes = function () {
        return this.as("minutes");
      }, u.hours = function () {
        return this.get("hours");
      }, u.asHours = function () {
        return this.as("hours");
      }, u.days = function () {
        return this.get("days");
      }, u.asDays = function () {
        return this.as("days");
      }, u.weeks = function () {
        return this.get("weeks");
      }, u.asWeeks = function () {
        return this.as("weeks");
      }, u.months = function () {
        return this.get("months");
      }, u.asMonths = function () {
        return this.as("months");
      }, u.years = function () {
        return this.get("years");
      }, u.asYears = function () {
        return this.as("years");
      }, s;
    }();
  return function (n, i, o) {
    t = o, s = o().$utils(), o.duration = function (t, s) {
      var n = o.locale();
      return r(t, {
        $l: n
      }, s);
    }, o.isDuration = e;
    var u = i.prototype.add,
      h = i.prototype.subtract;
    i.prototype.add = function (t, s) {
      return e(t) && (t = t.asMilliseconds()), u.bind(this)(t, s);
    }, i.prototype.subtract = function (t, s) {
      return e(t) && (t = t.asMilliseconds()), h.bind(this)(t, s);
    };
  };
});